<template>
  <div id="main-canvas">
    <projectHeaderFixed :parent="parent"/>
    <projectHeader
      class="hidden-sm hidden-md"
      :parent="parent"
      v-if="parent.selectedProject!==null && parent.projectGalleries!==null"
    />
    <smallHeader
      v-if="parent.selectedProject!==null && parent.projectGalleries!==null"
      :parent="parent"
      class="hidden-lg"
    />
    <projectView
      v-if="parent.selectedProject!==null && parent.projectGalleries!==null"
      :parent="parent"
      :currentProjectView="parent.currentProjectView"
      :gallery="parent.currentProjectView!==null?parent.projectGalleries[parent.currentProjectView.id]:[]"
    />
    <smallFooter
      :parent="parent"
      v-if="parent.currentProjectView!==null && parent.layout==='md'||parent.layout==='sm'"
    />
    <projectFooter
      :parent="parent"
      v-if="parent.currentProjectView!==null && parent.layout!=='md'&&parent.layout!=='sm'"
    />
  </div>
</template>

<script>
import ProjectNav from "../components/project-nav.vue";
import ProjectView from "../components/project-view.vue";
import projectHeader from "../components/project-header.vue";
import smallHeader from "../components/small-header.vue";
import smallFooter from "../components/small-footer.vue";
import projectHeaderFixed from "../components/project-header-fixed.vue";
import projectFooter from "../components/project-footer.vue";
export default {
  name: "main-canvas",
  components: {
    ProjectNav,
    ProjectView,
    projectHeader,
    smallHeader,
    smallFooter,
    projectFooter,
    projectHeaderFixed
  },
  props: ["parent"],
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#main-canvas {
  position: relative;
  height: 100%;
  width: 100%;
  margin-left: 90px;
}
.layout-md #main-canvas,
.layout-sm #main-canvas {
  margin-top: 135px;
  margin-left: 0;
}
</style>
